/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetCustomerNotificationsResponse } from '../model/getCustomerNotificationsResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CustomerNotificationServiceInterface }                            from './customerNotification.serviceInterface';


@Injectable()
export class CustomerNotificationService implements CustomerNotificationServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param applicationName 
     * @param applicationVersion 
     * @param os 
     * @param osVersion 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCustomerNotification1(organization?: string, login?: string, applicationName?: string, applicationVersion?: string, os?: string, osVersion?: string, locale?: string, observe?: 'body', reportProgress?: boolean): Observable<GetCustomerNotificationsResponse>;
    public getCustomerNotification1(organization?: string, login?: string, applicationName?: string, applicationVersion?: string, os?: string, osVersion?: string, locale?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetCustomerNotificationsResponse>>;
    public getCustomerNotification1(organization?: string, login?: string, applicationName?: string, applicationVersion?: string, os?: string, osVersion?: string, locale?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetCustomerNotificationsResponse>>;
    public getCustomerNotification1(organization?: string, login?: string, applicationName?: string, applicationVersion?: string, os?: string, osVersion?: string, locale?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (applicationName !== undefined && applicationName !== null) {
            queryParameters = queryParameters.set('applicationName', <any>applicationName);
        }
        if (applicationVersion !== undefined && applicationVersion !== null) {
            queryParameters = queryParameters.set('applicationVersion', <any>applicationVersion);
        }
        if (os !== undefined && os !== null) {
            queryParameters = queryParameters.set('os', <any>os);
        }
        if (osVersion !== undefined && osVersion !== null) {
            queryParameters = queryParameters.set('osVersion', <any>osVersion);
        }
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetCustomerNotificationsResponse>(`${this.basePath}/customernotification/info`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
